export const MAX_SENDABLE_HEALTH_RECORD_ATTACHMENTS = 50;

export const HEALTH_RECORD_ATTACHMENT_FORM_KEY_PREFIX = "attachment-";
